/**
 * Daisi Backend API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { Param } from '../param';
import { ApiConfigurationService } from '../../helpers/api-configuration.service';
import { HttpParamHelper } from '../../helpers/http-param-helper';
import { CustomHttpParameterCodec } from '../encoder';

import { COLLECTION_FORMATS } from '../variables';

@Injectable({
  providedIn: 'root',
})
export class IncidentReportControllerService {
  private readonly encoder: CustomHttpParameterCodec;
  private readonly httpClient = inject(HttpClient);
  protected readonly configuration = inject(ApiConfigurationService);

  constructor() {
    this.encoder = this.configuration.encoder;
  }

  public downloadIncidentReport(
    from: string,
    to: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/csv'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any>;
  public downloadIncidentReport(
    from: string,
    to: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/csv'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpResponse<any>>;
  public downloadIncidentReport(
    from: string,
    to: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'text/csv'; context?: HttpContext; transferCache?: boolean },
  ): Observable<HttpEvent<any>>;
  public downloadIncidentReport(
    from: string,
    to: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'text/csv'; context?: HttpContext; transferCache?: boolean },
  ): Observable<any> {
    if (from === null || from === undefined) {
      throw new Error(
        'Required parameter from was null or undefined when calling downloadIncidentReport.',
      );
    }
    if (to === null || to === undefined) {
      throw new Error(
        'Required parameter to was null or undefined when calling downloadIncidentReport.',
      );
    }
    let httpParams = new HttpParams({ encoder: this.encoder });
    if (from !== undefined && from !== null) {
      httpParams = HttpParamHelper.addToHttpParams(httpParams, from as any, 'from');
    }
    if (to !== undefined && to !== null) {
      httpParams = HttpParamHelper.addToHttpParams(httpParams, to as any, 'to');
    }
    return this.httpClient.request<any>('get', `/api/incident-report`, {
      params: httpParams,
      responseType: 'text/csv'.startsWith('text/') ? ('text' as 'json') : undefined,
      observe: observe,
    });
  }
}
